<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <label for="provincias">Etiqueta</label>
            <Button class="mb-3" @click="showModal('crear-etiqueta')" id="crear-etiqueta">Crear etiqueta</Button>
        </div>
        <multiselect
            v-if="etiquetas"
            v-model="etiqueta"
            id="etiquetas"
            name="etiquetas"
            placeholder="Etiquetas"
            label="name"
            track-by="value"
            :options="etiquetas"
            :multiple="false"
            open-direction="bottom"
            @select="(etiquetaSeleccionada) => $emit('seleccionada', etiquetaSeleccionada)"
        >
            >
            <span slot="noOptions">No hay etiquetas disponibles</span>
        </multiselect>
        <CrearEtiqueta
            :etiqueta="{}"
            @close="closeModal"
            @crear="crearEtiqueta"
        />
    </div>
</template>

<script>
    import CrearEtiqueta from '@/components/backend/etiquetas-bloqueos/modals/CrearEtiqueta';

    export default {
        data() {
            return {
                etiquetas: null,
                etiqueta: null
            }
        },
        methods: {
            getEtiquetas() {
                const params = {
                    filters: {
                        to_select: true
                    },
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.etiquetas.index'), params).then(res => {
                    this.etiquetas = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            crearEtiqueta(etiqueta) {
                etiqueta.teatro_id = this.teatro.id;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.etiquetas.crear'), etiqueta).then(res => {
                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.closeModal('crear-etiqueta');
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.getEtiquetas();
                this.$modal.hide(modal);
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getEtiquetas();
        },
        components: {
            CrearEtiqueta
        }
    }
</script>